<template lang="pug">
div
  el-card.card-container(shadow="hover")
    filtro(
      :configuracaoFiltro="configuracaoFiltro",
      :filtroRapido="filtroRapido",
      :showFiltroPublicacao="tipo === 'PUBLICACAO'",
      :showFiltroPublicacaoPortaria="tipo === 'PORTARIA_HOMOLOGACAO'",
      @pesquisar="pesquisar",
      @limpar="clear"
    )
  app-listagem(
    :has-refresh-button="true",
    :showButtonAssinatura="false",
    :has-expansivel="false",
    :json-headers="colunas",
    :json-data="items",
    :totalElements="totalElements",
    :pagina="filtro.pagina",
    :hasFiltroRapido="false",
    :filtro="filtro"
    :infoPrazos="false"
    :dadosNaoEncontrado="dadosNaoEncontrado"
    @atualizarFiltro="atualizarFiltro"
    @updateListagem="refresh",
    @changePage="changePage",
    @sort="sort",
    @executar="executar",
  )
</template>

<script>
import AppListagem from '@/components/AppListagem.vue'
import Filtro from '@/screens/analise/listagem/Filtro'
import FILTRO_EMPTY from '@/models/filtro'
import AppNotificacao from '@/components/mixins/AppNotificacao'
import AppModalVisualizarCompleto from '@/screens/analise/components/modal/AppModalVisualizarCompleto'
const BaseFiltro = require('@/screens/analise/listagem/' + process.env.ESTADO + '/BaseFiltro').default

export default {

  components: {
    AppListagem,
    Filtro,
    AppModalVisualizarCompleto
  },

  mixins: [
    BaseFiltro,
    AppNotificacao
  ],

  props: {
    tipo: {
      type: String,
      required: true
    }
  },

  data () {
    return {
      filtro: FILTRO_EMPTY(this.tipo),
      items: [],
      totalElements: 0,
      infoPrazos: undefined,
      setoresInfoVencimento: [ 'GAC', 'GEO', 'GCG', 'CGIR', 'DEAF', 'GDA', 'GRF', 'GAM', 'GEA', 'DJ', 'CDI', 'CPAV', 'GP', 'GIT',
        'PROTOCOLO', 'COMISSAO_ILHA', 'CAF', 'JURIDICO', 'DF1', 'DRF', 'DATGL', 'PRESIDENCIA', 'DUF', 'GRF_CAF',
        'GCG_CGIR'],
      processosSelecionados: [],
      showModalResponsavel: false,
      disabledAnalisar: false,
      showModalVisualizarProcesso: false,
      solicitarRetificacao: false,
      showModalAssinatura: false,
      showModalAvocar: false,
      processoTrocado: null,
      idProcesso: null,
      numeroProcesso: null,
      tipoProcesso: null,
      setorSelecionado: null,
      protocolo: null,
      idsProcessosAssinatura: [],
      idsProcessos: [],
      configuracaoFiltro: this.getConfiguracaoFiltro(this.tipo),
      colunas: this.getColunas(this.tipo),

      usuario: null,
      filtroRapido: null,
      isPa: process.env.ESTADO === 'pa',
      dadosNaoEncontrado: this.getDadosNaoEncontrado(this.tipo)
    }
  },

  watch: {
    async '$route' (to, from) {
      this.init()
    }
  },

  methods: {
    atualizarFiltro (novoFiltro) {
      this.filtroRapido = novoFiltro
    },
    getConfiguracaoFiltro (tipo) {
      if (tipo === 'PORTARIA_HOMOLOGACAO') {
        return {
          filtroNumeroPortaria: ['PORTARIA_HOMOLOGACAO'],
          filtroNumeroPublicacaoPortaria: ['PORTARIA_HOMOLOGACAO'],
          filtroDataPublicacaoPortaria: ['PORTARIA_HOMOLOGACAO'],
          filtroArea: ['PORTARIA_HOMOLOGACAO'],
          filtroDenominacao: ['PORTARIA_HOMOLOGACAO'],
          filtroMunicipio: ['PORTARIA_HOMOLOGACAO']
        }
      } else if (tipo === 'PUBLICACAO') {
        return {
          filtroNumeroPublicacao: ['PUBLICACAO'],
          filtroDataPublicacao: ['PUBLICACAO'],
          filtroArea: ['PUBLICACAO'],
          filtroDenominacao: ['PUBLICACAO'],
          filtroMunicipio: ['PUBLICACAO']
        }
      }
    },
    getColunas (tipo) {
      if (tipo === 'PORTARIA_HOMOLOGACAO') {
        return [
          { id: 1, titulo: 'Processo', propriedade: 'numeroProcesso', ordem: 1, acoes: [], sortable: false, type: 'icone', icone: 'comment-alt' },
          { id: 2, titulo: 'Nome/Razão Social do Interessado', propriedade: 'nome', ordem: 3, acoes: [], sortable: false },
          { id: 3, titulo: 'Denominação', propriedade: 'denominacao', ordem: 4, acoes: [], sortable: false },
          { id: 4, titulo: 'Área', propriedade: 'areaFormatada', ordem: 4, acoes: [], sortable: false },
          { id: 5, titulo: 'Município', propriedade: 'municipios', ordem: 3, acoes: [], sortable: false },
          { id: 6, titulo: 'Tipo de Processo', propriedade: 'tipoProcesso', ordem: 5, acoes: [], sortable: false },
          { id: 7, titulo: 'Data publicação', propriedade: 'data', ordem: 4, acoes: [], sortable: false },
          { id: 8, titulo: 'Número portaria', propriedade: 'numero', ordem: 5, acoes: [], sortable: false },
          { id: 9, titulo: 'Número de publicação', propriedade: 'numeroPublicacaoPortaria', ordem: 5, acoes: [], sortable: false }
        ]
      } else if (tipo === 'PUBLICACAO') {
        return [
          { id: 0, titulo: 'Processo', propriedade: 'numeroProcesso', ordem: 1, acoes: [], type: 'icone', icone: '' },
          { id: 1, titulo: 'Nome/Razão Social do Interessado', propriedade: 'nome', ordem: 3, acoes: [], sortable: false },
          { id: 2, titulo: 'Denominação', propriedade: 'denominacao', ordem: 4, acoes: [], sortable: false },
          { id: 3, titulo: 'Área', propriedade: 'areaFormatada', ordem: 4, acoes: [], sortable: false },
          { id: 4, titulo: 'Localização', propriedade: 'localizacao', ordem: 4, acoes: [], sortable: false },
          { id: 5, titulo: 'Municípios', propriedade: 'municipios', ordem: 3, acoes: [], sortable: false },
          { id: 6, titulo: 'Tipo de Processo', propriedade: 'tipoProcesso', ordem: 5, acoes: [], sortable: false },
          { id: 7, titulo: 'Data publicação', propriedade: 'data', ordem: 4, acoes: [], sortable: false },
          { id: 8, titulo: 'Número de publicação', propriedade: 'numeroPublicacaoPortaria', ordem: 5, acoes: [], sortable: false }
        ]
      }
    },
    getDadosNaoEncontrado (tipo) {
      if (tipo === 'PORTARIA_HOMOLOGACAO') {
        return 'Não foram encontradas homologações para o filtro informado.'
      } else if (tipo === 'PUBLICACAO') {
        return 'Não foram encontradas publicações para o filtro informado.'
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.card-container {
  margin: 20px;
  border-radius: 10px;
}

.padding-left {
  padding-left: 25px;
}
</style>



// WEBPACK FOOTER //
// src/screens/portal/publico/components/Listagem.vue